import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { InvoiceListCustomerCell } from './invoice-list-customer.cell';
import { InvoiceListCustomerHeader } from './invoice-list-customer.header';

export const InvoiceListCustomerColumn: IdentifiedColumnDef<
  InvoiceModel,
  InvoiceModel['customer']
> = {
  enableSorting: false,
  header: InvoiceListCustomerHeader,
  cell: InvoiceListCustomerCell,
  meta: { maxWidth: '200px' },
};
